import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { animateScroll } from 'react-scroll';
import { useTheme } from 'styled-components';
import { classNames } from '../../utils/styles';
import { SectionTitle } from '../styles';
import { LeftIcon } from './icons/Left';
import { RightIcon } from './icons/Right';
import { Cards, CardImage, CatalogSectionContainer, CircleNavigationButton, } from './styles';
import { useHorizontalScroll } from './useHorizontalScroll';
const navigationScrollIncrement = 300;
export const Catalog = ({ section }) => {
    const theme = useTheme();
    const { pageTitle, items, id } = section;
    const showTitle = !!pageTitle;
    const showNavigationButtons = items.length > 2;
    const { scrollRef, navigationControl } = useHorizontalScroll();
    const navigationRightHandler = (position) => {
        animateScroll.scrollTo(position, {
            containerId: scrollRef.current?.id,
            horizontal: true,
            smoth: true,
            duration: 500,
        });
    };
    return items.length ? (_jsxs(CatalogSectionContainer, { children: [showTitle && (_jsx(SectionTitle, { className: "title", children: pageTitle })), _jsx(Cards, { ref: scrollRef, id: `cards-${id}`, children: items.map((item) => (_jsxs("div", { onClick: () => window.open(item.link), className: classNames('card', {
                        'full-width': items.length === 1,
                        bpt: !showTitle,
                    }), children: [_jsx(CardImage, { "$image": item.image }), _jsxs("div", { className: "info", children: [_jsxs("div", { children: [_jsx("h5", { className: "semibold", children: item.title }), _jsx("p", { children: item.description })] }), _jsx("div", { children: _jsx("h6", { children: item.linkTitle }) })] })] }, item.id))) }), showNavigationButtons && (_jsxs("div", { className: "navigation-section", children: [_jsx(CircleNavigationButton, { className: classNames({
                            disabled: navigationControl.previousDisabled,
                        }), onClick: () => navigationRightHandler((scrollRef.current?.scrollLeft || 0) -
                            navigationScrollIncrement), children: _jsx(LeftIcon, { color: theme.secondary }) }), _jsx(CircleNavigationButton, { className: classNames({
                            disabled: navigationControl.nextDisabled,
                        }), onClick: () => navigationRightHandler((scrollRef.current?.scrollLeft || 0) +
                            navigationScrollIncrement), children: _jsx(RightIcon, { color: theme.secondary }) })] }))] })) : null;
};
